import { FC } from "react";
import { TransferScanModal } from "./TransferScanModal";
import { TransferScanErrorModal, TransferScanErrorModalProps } from "./TransferScanErrorModal";

export const transferScanModalMap: Record<TransferScanModal, FC<any>> = {
  [TransferScanModal.GAYLORD_NOT_FOUND]: TransferScanErrorModal,
  [TransferScanModal.GAYLORD_NOT_ELIGIBLE]: TransferScanErrorModal,
  [TransferScanModal.UNKNOWN_ERROR]: TransferScanErrorModal,
};

export const transferScanMessageMap: Record<TransferScanModal, TransferScanErrorModalProps> = {
  [TransferScanModal.GAYLORD_NOT_FOUND]: {
    title: "Gaylord not found",
    text: "The gaylord scanned is not valid. Please check the barcode and try again.",
    hideModalValue: TransferScanModal.GAYLORD_NOT_FOUND,
  },
  [TransferScanModal.GAYLORD_NOT_ELIGIBLE]: {
    title: "Gaylord not eligible for transfer",
    text: "This Gaylord is not pre-sorted for this sort center.",
    hideModalValue: TransferScanModal.GAYLORD_NOT_ELIGIBLE,
  },
  [TransferScanModal.UNKNOWN_ERROR]: {
    title: "Unknown error",
    text: "An unknown error occurred. Please try again. Contact a supervisor if the issue persists.",
    hideModalValue: TransferScanModal.UNKNOWN_ERROR,
  },
};
